import { useState } from 'react';

function PhotosGallery({ photos }) {
  const [zoomSrc, setZoomSrc] = useState(null);

  return (
    <div>
      <div className="d-flex flex-wrap">
        {photos &&
          photos.map((p, i) => (
            <img
              key={i}
              src={p}
              alt=""
              style={{
                width: 160,
                margin: 4,
                borderRadius: 6,
                cursor: 'pointer',
              }}
              onClick={() => setZoomSrc(p)}
            />
          ))}
      </div>

      {zoomSrc && (
        <div
          onClick={() => setZoomSrc(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            cursor: 'zoom-out',
          }}
        >
          <img
            src={zoomSrc}
            alt=""
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              borderRadius: 10,
            }}
          />
        </div>
      )}
    </div>
  );
}

export default PhotosGallery;
